import type { ServicesDetailData } from '@/data/types';
import { resolveImagePath } from '@/utils/imageMap';

interface ServicesDetailProps {
  data: ServicesDetailData;
}

export function ServicesDetail({ data }: ServicesDetailProps) {
  const imageUrl = resolveImagePath(data.image.src);

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          {/* Image */}
          <div className="lg:w-1/2">
            <img
              src={imageUrl}
              alt={data.image.alt}
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
          
          {/* Content */}
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-red-500 mb-6">
              {data.title}
            </h2>
            <div 
              className="text-lg text-gray-700 mb-8 leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: data.description.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
              }}
            />
            <a
              href={data.readMoreLink}
              className="inline-block bg-red-500 text-white px-8 py-3 rounded-md font-semibold hover:bg-red-600 transition-colors"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}